import React from 'react';
import Alert from '@mui/lab/Alert';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const UiAlert = (props) => {
  const { children, className, ...restProps } = props;
  return (
    <Alert className={classNames('ui-alert', className)} {...restProps}>
      {children}
    </Alert>
  );
};

UiAlert.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

export default UiAlert;
